import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-town-selector',
  templateUrl: './town-selector.component.html',
  styleUrls: ['./town-selector.component.scss']
})
export class TownSelectorComponent implements OnInit {
  data = [
      {
          name: 'Branford',
          lat: 41.235046,
          lon: -72.816795,
          depth: 30,

          table: [
            { rp: 2, h: 4.59, hs: 2.76 },
            { rp: 3, h: 5.43, hs: 4.77 },
            { rp: 4, h: 5.88, hs: 5.96 },
            { rp: 5, h: 6.19, hs: 6.80 },
            { rp: 6, h: 6.41, hs: 7.44 },
            { rp: 7, h: 6.58, hs: 7.95 },
            { rp: 8, h: 6.72, hs: 8.38 },
            { rp: 9, h: 6.84, hs: 8.74 },
            { rp: 10, h: 6.94, hs: 9.06 },
            { rp: 20, h: 7.49, hs: 10.97 },
            { rp: 30, h: 7.77, hs: 11.96 },
            { rp: 40, h: 7.91, hs: 12.62 },
            { rp: 50, h: 8.02, hs: 13.10 },
            { rp: 60, h: 8.11, hs: 13.49 },
            { rp: 70, h: 8.18, hs: 13.80 },
            { rp: 80, h: 8.23, hs: 14.06 },
            { rp: 90, h: 8.28, hs: 14.29 },
            { rp: 100, h: 8.32, hs: 14.49 },
            { rp: 200, h: 8.55, hs: 15.71 },
            { rp: 300, h: 8.66, hs: 16.36 },
            { rp: 400, h: 8.73, hs: 16.79 },
            { rp: 500, h: 8.77, hs: 17.11 },
          ],

          img1: 'assets/water_level/Branford_wl.png',

          img2: 'assets/wave/Branford_wave.png',
      },
      {
        name: 'Clinton',
        lat: 41.247456,
        lon: -72.52144,
        depth: 26,

        table: [
          { rp: 2, h: 3.92, hs: 3.44 },
          { rp: 3, h: 4.72, hs: 5.73 },
          { rp: 4, h: 5.16, hs: 7.09 },
          { rp: 5, h: 5.45, hs: 8.05 },
          { rp: 6, h: 5.67, hs: 8.78 },
          { rp: 7, h: 5.84, hs: 9.37 },
          { rp: 8, h: 5.97, hs: 9.86 },
          { rp: 9, h: 6.09, hs: 10.28 },
          { rp: 10, h: 6.19, hs: 10.65 },
          { rp: 20, h: 6.74, hs: 12.85 },
          { rp: 30, h: 7.00, hs: 14.00 },
          { rp: 40, h: 7.16, hs: 14.76 },
          { rp: 50, h: 7.28, hs: 15.33 },
          { rp: 60, h: 7.37, hs: 15.77 },
          { rp: 70, h: 7.44, hs: 16.14 },
          { rp: 80, h: 7.50, hs: 16.45 },
          { rp: 90, h: 7.55, hs: 16.71 },
          { rp: 100, h: 7.59, hs: 16.95 },
          { rp: 200, h: 7.83, hs: 18.38 },
          { rp: 300, h: 7.95, hs: 19.14 },
          { rp: 400, h: 8.02, hs: 19.65 },
          { rp: 500, h: 8.07, hs: 20.03 },
        ],

        img1: 'assets/water_level/Clinton_wl.png',

        img2: 'assets/wave/Clinton_wave.png',
    },
    {
      name: 'Darien',
      lat: 41.045628,
      lon: -73.46477,
      depth: 22,

      table: [
        { rp: 2, h: 5.52, hs: 3.07 },
        { rp: 3, h: 6.35, hs: 4.56 },
        { rp: 4, h: 6.82, hs: 5.47 },
        { rp: 5, h: 7.14, hs: 6.11 },
        { rp: 6, h: 7.39, hs: 6.61 },
        { rp: 7, h: 7.58, hs: 7.01 },
        { rp: 8, h: 7.74, hs: 7.35 },
        { rp: 9, h: 7.88, hs: 7.64 },
        { rp: 10, h: 8.00, hs: 7.90 },
        { rp: 20, h: 8.68, hs: 9.46 },
        { rp: 30, h: 9.02, hs: 10.29 },
        { rp: 40, h: 9.25, hs: 10.85 },
        { rp: 50, h: 9.41, hs: 11.27 },
        { rp: 60, h: 9.53, hs: 11.61 },
        { rp: 70, h: 9.63, hs: 11.88 },
        { rp: 80, h: 9.72, hs: 12.12 },
        { rp: 90, h: 9.79, hs: 12.32 },
        { rp: 100, h: 9.85, hs: 12.50 },
        { rp: 200, h: 10.23, hs: 13.62 },
        { rp: 100, h: 10.42, hs: 14.23 },
        { rp: 100, h: 10.54, hs: 14.64 },
        { rp: 100, h: 10.63, hs: 14.95 },
      ],

      img1: 'assets/water_level/Darien_wl.png',

      img2: 'assets/wave/Darien_wave.png',
  },
  {
    name: 'Greenwich',
    lat: 40.99335,
    lon: -73.5839,
    depth: 43,

    table: [
      { rp: 2, h: 5.51, hs: 3.05 },
      { rp: 3, h: 6.48, hs: 4.56 },
      { rp: 4, h: 7.00, hs: 5.47 },
      { rp: 5, h: 7.35, hs: 6.08 },
      { rp: 6, h: 7.61, hs: 6.55 },
      { rp: 7, h: 7.81, hs: 6.93 },
      { rp: 8, h: 7.97, hs: 7.25 },
      { rp: 9, h: 8.11, hs: 7.52 },
      { rp: 10, h: 8.22, hs: 7.76 },
      { rp: 20, h: 8.87, hs: 9.16 },
      { rp: 30, h: 9.17, hs: 9.89 },
      { rp: 40, h: 9.36, hs: 10.36 },
      { rp: 50, h: 9.50, hs: 10.72 },
      { rp: 60, h: 9.60, hs: 10.99 },
      { rp: 70, h: 9.68, hs: 11.22 },
      { rp: 80, h: 9.74, hs: 11.41 },
      { rp: 90, h: 9.80, hs: 11.58 },
      { rp: 100, h: 9.85, hs: 11.72 },
      { rp: 200, h: 10.12, hs: 12.60 },
      { rp: 300, h: 10.25, hs: 13.06 },
      { rp: 400, h: 10.34, hs: 13.36 },
      { rp: 500, h: 10.39, hs: 13.59 },
    ],

    img1: 'assets/water_level/Greenwich_wl.png',

    img2: 'assets/wave/Greenwich_wave.png',
  },
  {
    name: 'Stamford',
    lat: 41.01703,
    lon: -73.54133,
    depth: 17,

    table: [
      { rp: 2, h: 5.56, hs: 3.20 },
      { rp: 3, h: 6.42, hs: 4.77 },
      { rp: 4, h: 6.92, hs: 5.74 },
      { rp: 5, h: 7.26, hs: 6.44 },
      { rp: 6, h: 7.52, hs: 6.99 },
      { rp: 7, h: 7.72, hs: 7.44 },
      { rp: 8, h: 7.89, hs: 7.82 },
      { rp: 9, h: 8.03, hs: 8.15 },
      { rp: 10, h: 8.15, hs: 8.44 },
      { rp: 20, h: 8.86, hs: 10.25 },
      { rp: 30, h: 9.22, hs: 11.25 },
      { rp: 40, h: 9.45, hs: 11.94 },
      { rp: 50, h: 9.62, hs: 12.46 },
      { rp: 60, h: 9.74, hs: 12.87 },
      { rp: 70, h: 9.85, hs: 13.22 },
      { rp: 80, h: 9.94, hs: 13.52 },
      { rp: 90, h: 10.01, hs: 13.78 },
      { rp: 100, h: 10.08, hs: 14.01 },
      { rp: 200, h: 10.46, hs: 15.47 },
      { rp: 300, h: 10.66, hs: 16.30 },
      { rp: 400, h: 10.79, hs: 16.86 },
      { rp: 500, h: 10.88, hs: 17.29 },
    ],

    img1: 'assets/water_level/Stamford_wl.png',

    img2: 'assets/wave/Stamford_wave.png',
  },
  {
    name: 'Norwalk',
    lat: 41.075855,
    lon: -73.39845,
    depth: 14,

    table: [
      { rp: 2, h: 5.41, hs: 3.35 },
      { rp: 3, h: 6.31, hs: 4.93 },
      { rp: 4, h: 6.80, hs: 5.92 },
      { rp: 5, h: 7.12, hs: 6.65 },
      { rp: 6, h: 7.36, hs: 7.22 },
      { rp: 7, h: 7.54, hs: 7.69 },
      { rp: 8, h: 7.69, hs: 8.09 },
      { rp: 9, h: 7.81, hs: 8.44 },
      { rp: 10, h: 7.92, hs: 8.75 },
      { rp: 20, h: 8.51, hs: 10.69 },
      { rp: 30, h: 8.78, hs: 11.78 },
      { rp: 40, h: 8.95, hs: 12.54 },
      { rp: 50, h: 9.07, hs: 13.12 },
      { rp: 60, h: 9.16, hs: 13.59 },
      { rp: 70, h: 9.23, hs: 13.98 },
      { rp: 80, h: 9.29, hs: 14.32 },
      { rp: 90, h: 9.34, hs: 14.61 },
      { rp: 100, h: 9.38, hs: 14.88 },
      { rp: 200, h: 9.62, hs: 16.57 },
      { rp: 300, h: 9.74, hs: 17.54 },
      { rp: 400, h: 9.81, hs: 18.21 },
      { rp: 500, h: 9.86, hs: 18.73 },
    ],

    img1: 'assets/water_level/Norwalk_wl.png',

    img2: 'assets/wave/Norwalk_wave.png',
  },
  {
    name: 'Westport',
    lat: 41.100708,
    lon: -73.36369,
    depth: 13,

    table: [
      { rp: 2, h: 5.26, hs: 2.92 },
      { rp: 3, h: 6.19, hs: 4.28 },
      { rp: 4, h: 6.69, hs: 5.16 },
      { rp: 5, h: 7.03, hs: 5.81 },
      { rp: 6, h: 7.27, hs: 6.33 },
      { rp: 7, h: 7.46, hs: 6.76 },
      { rp: 8, h: 7.62, hs: 7.13 },
      { rp: 9, h: 7.75, hs: 7.45 },
      { rp: 10, h: 7.85, hs: 7.74 },
      { rp: 20, h: 8.45, hs: 9.60 },
      { rp: 30, h: 8.73, hs: 10.68 },
      { rp: 40, h: 8.90, hs: 11.44 },
      { rp: 50, h: 9.03, hs: 12.03 },
      { rp: 60, h: 9.12, hs: 12.52 },
      { rp: 70, h: 9.19, hs: 12.93 },
      { rp: 80, h: 9.25, hs: 13.28 },
      { rp: 90, h: 9.30, hs: 13.59 },
      { rp: 100, h: 9.34, hs: 13.87 },
      { rp: 200, h: 9.58, hs: 15.71 },
      { rp: 300, h: 9.70, hs: 16.79 },
      { rp: 400, h: 9.77, hs: 17.56 },
      { rp: 500, h: 9.82, hs: 18.16 },
    ],

    img1: 'assets/water_level/Westport_wl.png',

    img2: 'assets/wave/Westport_wave.png',
  },
  {
    name: 'Fairfield',
    lat: 41.10282,
    lon: -73.259476,
    depth: 47,

    table: [
      { rp: 2, h: 5.26, hs: 4.40 },
      { rp: 3, h: 6.12, hs: 5.91 },
      { rp: 4, h: 6.60, hs: 6.87 },
      { rp: 5, h: 6.92, hs: 7.57 },
      { rp: 6, h: 7.15, hs: 8.12 },
      { rp: 7, h: 7.33, hs: 8.58 },
      { rp: 8, h: 7.48, hs: 8.98 },
      { rp: 9, h: 7.61, hs: 9.32 },
      { rp: 10, h: 7.71, hs: 9.62 },
      { rp: 20, h: 8.31, hs: 11.55 },
      { rp: 30, h: 8.60, hs: 12.64 },
      { rp: 40, h: 8.77, hs: 13.41 },
      { rp: 50, h: 8.90, hs: 13.99 },
      { rp: 60, h: 9.00, hs: 14.47 },
      { rp: 70, h: 9.07, hs: 14.87 },
      { rp: 80, h: 9.14, hs: 15.22 },
      { rp: 90, h: 9.19, hs: 15.52 },
      { rp: 100, h: 9.24, hs: 15.79 },
      { rp: 200, h: 9.50, hs: 17.55 },
      { rp: 300, h: 9.63, hs: 18.56 },
      { rp: 400, h: 9.71, hs: 19.28 },
      { rp: 500, h: 9.77, hs: 19.83 },
    ],

    img1: 'assets/water_level/Fairfield_wl.png',

    img2: 'assets/wave/Fairfield_wave.png',
  },
  {
    name: 'Bridgeport',
    lat: 41.14083,
    lon: -73.20517,
    depth: 25,

    table: [
      { rp: 2, h: 5.27, hs: 3.75 },
      { rp: 3, h: 6.09, hs: 5.44 },
      { rp: 4, h: 6.54, hs: 6.48 },
      { rp: 5, h: 6.85, hs: 7.21 },
      { rp: 6, h: 7.07, hs: 7.78 },
      { rp: 7, h: 7.25, hs: 8.25 },
      { rp: 8, h: 7.39, hs: 8.64 },
      { rp: 9, h: 7.51, hs: 8.98 },
      { rp: 10, h: 7.62, hs: 9.27 },
      { rp: 20, h: 8.20, hs: 11.09 },
      { rp: 30, h: 8.48, hs: 12.07 },
      { rp: 40, h: 8.66, hs: 12.74 },
      { rp: 50, h: 8.78, hs: 13.24 },
      { rp: 60, h: 8.88, hs: 13.63 },
      { rp: 70, h: 8.95, hs: 13.96 },
      { rp: 80, h: 9.02, hs: 14.24 },
      { rp: 90, h: 9.07, hs: 14.49 },
      { rp: 100, h: 9.12, hs: 14.70 },
      { rp: 200, h: 9.38, hs: 16.05 },
      { rp: 300, h: 9.51, hs: 16.80 },
      { rp: 400, h: 9.60, hs: 17.30 },
      { rp: 500, h: 9.66, hs: 17.68 },
    ],

    img1: 'assets/water_level/Bridgeport_wl.png',

    img2: 'assets/wave/Bridgeport_wave.png',
  },
  {
    name: 'Stratford',
    lat: 41.133266,
    lon: -73.10705,
    depth: 29,

    table: [
      { rp: 2, h: 5.12, hs: 3.80 },
      { rp: 3, h: 5.97, hs: 6.06 },
      { rp: 4, h: 6.42, hs: 7.38 },
      { rp: 5, h: 6.72, hs: 8.30 },
      { rp: 6, h: 6.93, hs: 9.00 },
      { rp: 7, h: 7.10, hs: 9.56 },
      { rp: 8, h: 7.23, hs: 10.03 },
      { rp: 9, h: 7.34, hs: 10.43 },
      { rp: 10, h: 7.44, hs: 10.77 },
      { rp: 20, h: 7.94, hs: 12.82 },
      { rp: 30, h: 8.17, hs: 13.87 },
      { rp: 40, h: 8.31, hs: 14.57 },
      { rp: 50, h: 8.41, hs: 15.08 },
      { rp: 60, h: 8.48, hs: 15.47 },
      { rp: 70, h: 8.54, hs: 15.80 },
      { rp: 80, h: 8.59, hs: 16.07 },
      { rp: 90, h: 8.63, hs: 16.31 },
      { rp: 100, h: 8.66, hs: 16.51 },
      { rp: 200, h: 8.85, hs: 17.76 },
      { rp: 300, h: 8.93, hs: 18.42 },
      { rp: 400, h: 8.99, hs: 18.85 },
      { rp: 500, h: 9.02, hs: 19.17 },
    ],

    img1: 'assets/water_level/Stratford_wl.png',

    img2: 'assets/wave/Stratford_wave.png',
  },
  {
    name: 'Milford',
    lat: 41.184357,
    lon: -73.04857,
    depth: 16,

    table: [
      { rp: 2, h: 5.03, hs: 2.50 },
      { rp: 3, h: 5.82, hs: 4.86 },
      { rp: 4, h: 6.26, hs: 6.23 },
      { rp: 5, h: 6.54, hs: 7.18 },
      { rp: 6, h: 6.76, hs: 7.89 },
      { rp: 7, h: 6.92, hs: 8.46 },
      { rp: 8, h: 7.05, hs: 8.93 },
      { rp: 9, h: 7.16, hs: 9.33 },
      { rp: 10, h: 7.26, hs: 9.67 },
      { rp: 20, h: 7.78, hs: 11.70 },
      { rp: 30, h: 8.02, hs: 12.72 },
      { rp: 40, h: 8.17, hs: 13.39 },
      { rp: 50, h: 8.28, hs: 13.87 },
      { rp: 60, h: 8.36, hs: 14.25 },
      { rp: 70, h: 8.43, hs: 14.56 },
      { rp: 80, h: 8.48, hs: 14.81 },
      { rp: 90, h: 8.52, hs: 15.03 },
      { rp: 100, h: 8.56, hs: 15.23 },
      { rp: 200, h: 8.78, hs: 16.38 },
      { rp: 300, h: 8.88, hs: 16.97 },
      { rp: 400, h: 8.94, hs: 17.36 },
      { rp: 500, h: 8.99, hs: 17.64 },
    ],

    img1: 'assets/water_level/Milford_wl.png',

    img2: 'assets/wave/Milford_wave.png',
  },
  {
    name: 'West Haven',
    lat: 41.226807,
    lon: -72.95259,
    depth: 21,

    table: [
      { rp: 2, h: 4.83, hs: 2.42 },
      { rp: 3, h: 5.66, hs: 4.31 },
      { rp: 4, h: 6.11, hs: 5.46 },
      { rp: 5, h: 6.40, hs: 6.26 },
      { rp: 6, h: 6.62, hs: 6.89 },
      { rp: 7, h: 6.78, hs: 7.39 },
      { rp: 8, h: 6.91, hs: 7.81 },
      { rp: 9, h: 7.02, hs: 8.18 },
      { rp: 10, h: 7.12, hs: 8.49 },
      { rp: 20, h: 7.63, hs: 10.42 },
      { rp: 30, h: 7.86, hs: 11.44 },
      { rp: 40, h: 8.01, hs: 12.13 },
      { rp: 50, h: 8.11, hs: 12.64 },
      { rp: 60, h: 8.18, hs: 13.04 },
      { rp: 70, h: 8.24, hs: 13.38 },
      { rp: 80, h: 8.29, hs: 13.66 },
      { rp: 90, h: 8.33, hs: 13.91 },
      { rp: 100, h: 8.37, hs: 14.12 },
      { rp: 200, h: 8.56, hs: 15.46 },
      { rp: 300, h: 8.66, hs: 16.18 },
      { rp: 400, h: 8.71, hs: 16.67 },
      { rp: 500, h: 8.75, hs: 17.04 },
    ],

    img1: 'assets/water_level/West Haven_wl.png',

    img2: 'assets/wave/West Haven_wave.png',
  },
  {
    name: 'New Haven',
    lat: 41.23464,
    lon: -72.91723,
    depth: 20,

    table: [
      { rp: 2, h: 4.80, hs: 2.58 },
      { rp: 3, h: 5.63, hs: 4.27 },
      { rp: 4, h: 6.07, hs: 5.28 },
      { rp: 5, h: 6.37, hs: 6.01 },
      { rp: 6, h: 6.58, hs: 6.56 },
      { rp: 7, h: 6.75, hs: 7.01 },
      { rp: 8, h: 6.88, hs: 7.39 },
      { rp: 9, h: 6.99, hs: 7.71 },
      { rp: 10, h: 7.09, hs: 8.00 },
      { rp: 20, h: 7.60, hs: 9.72 },
      { rp: 30, h: 7.84, hs: 10.64 },
      { rp: 40, h: 7.99, hs: 11.26 },
      { rp: 50, h: 8.09, hs: 11.72 },
      { rp: 60, h: 8.17, hs: 12.08 },
      { rp: 70, h: 8.23, hs: 12.38 },
      { rp: 80, h: 8.28, hs: 12.64 },
      { rp: 90, h: 8.32, hs: 12.86 },
      { rp: 100, h: 8.36, hs: 13.05 },
      { rp: 200, h: 8.56, hs: 14.26 },
      { rp: 300, h: 8.65, hs: 14.92 },
      { rp: 400, h: 8.71, hs: 15.36 },
      { rp: 500, h: 8.76, hs: 15.69 },
    ],

    img1: 'assets/water_level/New Haven_wl.png',

    img2: 'assets/wave/New Haven_wave.png',
  },
  {
    name: 'East Haven',
    lat: 41.23161,
    lon: -72.87202,
    depth: 25,

    table: [
      { rp: 2, h: 4.70, hs: 2.69 },
      { rp: 3, h: 5.52, hs: 4.70 },
      { rp: 4, h: 5.97, hs: 5.90 },
      { rp: 5, h: 6.27, hs: 6.76 },
      { rp: 6, h: 6.48, hs: 7.42 },
      { rp: 7, h: 6.65, hs: 7.95 },
      { rp: 8, h: 6.79, hs: 8.39 },
      { rp: 9, h: 6.90, hs: 8.78 },
      { rp: 10, h: 7.00, hs: 9.11 },
      { rp: 20, h: 7.54, hs: 11.13 },
      { rp: 30, h: 7.79, hs: 12.20 },
      { rp: 40, h: 7.95, hs: 12.92 },
      { rp: 50, h: 8.06, hs: 13.45 },
      { rp: 60, h: 8.14, hs: 13.87 },
      { rp: 70, h: 8.21, hs: 14.22 },
      { rp: 80, h: 8.26, hs: 14.52 },
      { rp: 90, h: 8.31, hs: 14.77 },
      { rp: 100, h: 8.35, hs: 15.00 },
      { rp: 200, h: 8.57, hs: 16.38 },
      { rp: 300, h: 8.68, hs: 17.13 },
      { rp: 400, h: 8.74, hs: 17.64 },
      { rp: 500, h: 8.79, hs: 18.01 },
    ],

    img1: 'assets/water_level/East Haven_wl.png',

    img2: 'assets/wave/East Haven_wave.png',
  },
  {
    name: 'Guilford',
    lat: 41.243362,
    lon: -72.674,
    depth: 27,

    table: [
      { rp: 2, h: 4.36, hs: 1.24 },
      { rp: 3, h: 5.14, hs: 4.72 },
      { rp: 4, h: 5.58, hs: 6.52 },
      { rp: 5, h: 5.87, hs: 7.67 },
      { rp: 6, h: 6.09, hs: 8.49 },
      { rp: 7, h: 6.26, hs: 9.12 },
      { rp: 8, h: 6.40, hs: 9.61 },
      { rp: 9, h: 6.52, hs: 10.02 },
      { rp: 10, h: 6.62, hs: 10.36 },
      { rp: 20, h: 7.18, hs: 12.16 },
      { rp: 30, h: 7.45, hs: 12.94 },
      { rp: 40, h: 7.63, hs: 13.41 },
      { rp: 50, h: 7.75, hs: 13.73 },
      { rp: 60, h: 7.84, hs: 13.96 },
      { rp: 70, h: 7.92, hs: 14.14 },
      { rp: 80, h: 7.98, hs: 14.29 },
      { rp: 90, h: 8.03, hs: 14.41 },
      { rp: 100, h: 8.07, hs: 14.51 },
      { rp: 200, h: 8.34, hs: 15.08 },
      { rp: 300, h: 8.46, hs: 15.33 },
      { rp: 400, h: 8.55, hs: 15.48 },
      { rp: 500, h: 8.60, hs: 15.58 },
    ],

    img1: 'assets/water_level/Guilford_wl.png',

    img2: 'assets/wave/Guilford_wave.png',
  },
  {
    name: 'Madison',
    lat: 41.24982,
    lon: -72.59984,
    depth: 26,

    table: [
      { rp: 2, h: 4.15, hs: 1.98 },
      { rp: 3, h: 4.95, hs: 5.15 },
      { rp: 4, h: 5.40, hs: 6.73 },
      { rp: 5, h: 5.70, hs: 7.72 },
      { rp: 6, h: 5.92, hs: 8.41 },
      { rp: 7, h: 6.10, hs: 8.93 },
      { rp: 8, h: 6.24, hs: 9.33 },
      { rp: 9, h: 6.36, hs: 9.66 },
      { rp: 10, h: 6.46, hs: 9.94 },
      { rp: 20, h: 7.03, hs: 11.34 },
      { rp: 30, h: 7.31, hs: 11.93 },
      { rp: 40, h: 7.48, hs: 12.26 },
      { rp: 50, h: 7.60, hs: 12.49 },
      { rp: 60, h: 7.70, hs: 12.65 },
      { rp: 70, h: 7.77, hs: 12.78 },
      { rp: 80, h: 7.83, hs: 12.88 },
      { rp: 90, h: 7.89, hs: 12.96 },
      { rp: 100, h: 7.93, hs: 13.03 },
      { rp: 200, h: 8.19, hs: 13.39 },
      { rp: 300, h: 8.32, hs: 13.55 },
      { rp: 400, h: 8.40, hs: 13.64 },
      { rp: 500, h: 8.46, hs: 13.70 },
    ],

    img1: 'assets/water_level/Madison_wl.png',

    img2: 'assets/wave/Madison_wave.png',
  },
  {
    name: 'Westbrook',
    lat: 41.264305,
    lon: -72.443596,
    depth: 24,

    table: [
      { rp: 2, h: 3.73, hs: 3.45 },
      { rp: 3, h: 4.51, hs: 5.57 },
      { rp: 4, h: 4.93, hs: 6.86 },
      { rp: 5, h: 5.21, hs: 7.78 },
      { rp: 6, h: 5.42, hs: 8.48 },
      { rp: 7, h: 5.59, hs: 9.06 },
      { rp: 8, h: 5.72, hs: 9.54 },
      { rp: 9, h: 5.83, hs: 9.95 },
      { rp: 10, h: 5.92, hs: 10.31 },
      { rp: 20, h: 6.45, hs: 12.53 },
      { rp: 30, h: 6.70, hs: 13.72 },
      { rp: 40, h: 6.85, hs: 14.52 },
      { rp: 50, h: 6.96, hs: 15.12 },
      { rp: 60, h: 7.05, hs: 15.59 },
      { rp: 70, h: 7.11, hs: 15.98 },
      { rp: 80, h: 7.17, hs: 16.32 },
      { rp: 90, h: 7.21, hs: 16.61 },
      { rp: 100, h: 7.25, hs: 16.86 },
      { rp: 200, h: 7.48, hs: 18.45 },
      { rp: 300, h: 7.59, hs: 19.32 },
      { rp: 400, h: 7.66, hs: 19.90 },
      { rp: 500, h: 7.71, hs: 20.34 },
    ],

    img1: 'assets/water_level/Westbrook_wl.png',

    img2: 'assets/wave/Westbrook_wave.png',
  },
  {
    name: 'Old Saybrook',
    lat: 41.25185,
    lon: -72.370384,
    depth: 28,

    table: [
      { rp: 2, h: 3.31, hs: 4.58 },
      { rp: 3, h: 4.13, hs: 6.91 },
      { rp: 4, h: 4.57, hs: 8.31 },
      { rp: 5, h: 4.86, hs: 9.30 },
      { rp: 6, h: 5.07, hs: 10.06 },
      { rp: 7, h: 5.23, hs: 10.67 },
      { rp: 8, h: 5.36, hs: 11.19 },
      { rp: 9, h: 5.47, hs: 11.63 },
      { rp: 10, h: 5.56, hs: 12.01 },
      { rp: 20, h: 6.05, hs: 14.34 },
      { rp: 30, h: 6.28, hs: 15.56 },
      { rp: 40, h: 6.41, hs: 16.39 },
      { rp: 50, h: 6.51, hs: 17.00 },
      { rp: 60, h: 6.58, hs: 17.48 },
      { rp: 70, h: 6.64, hs: 17.88 },
      { rp: 80, h: 6.68, hs: 18.21 },
      { rp: 90, h: 6.72, hs: 18.50 },
      { rp: 100, h: 6.75, hs: 18.76 },
      { rp: 200, h: 6.94, hs: 20.34 },
      { rp: 300, h: 7.02, hs: 21.19 },
      { rp: 400, h: 7.08, hs: 21.76 },
      { rp: 500, h: 7.11, hs: 22.18 },
    ],

    img1: 'assets/water_level/Old Saybrook_wl.png',

    img2: 'assets/wave/Old Saybrook_wave.png',
  },
  {
    name: 'Old Lyme',
    lat: 41.254517,
    lon: -72.32015,
    depth: 23,

    table: [
      { rp: 2, h: 3.23, hs: 4.57 },
      { rp: 3, h: 3.95, hs: 6.76 },
      { rp: 4, h: 4.36, hs: 8.10 },
      { rp: 5, h: 4.63, hs: 9.07 },
      { rp: 6, h: 4.83, hs: 9.82 },
      { rp: 7, h: 4.99, hs: 10.43 },
      { rp: 8, h: 5.12, hs: 10.94 },
      { rp: 9, h: 5.23, hs: 11.39 },
      { rp: 10, h: 5.32, hs: 11.78 },
      { rp: 20, h: 5.85, hs: 14.19 },
      { rp: 30, h: 6.11, hs: 15.50 },
      { rp: 40, h: 6.27, hs: 16.39 },
      { rp: 50, h: 6.39, hs: 17.06 },
      { rp: 60, h: 6.48, hs: 17.59 },
      { rp: 70, h: 6.55, hs: 18.04 },
      { rp: 80, h: 6.60, hs: 18.42 },
      { rp: 90, h: 6.65, hs: 18.75 },
      { rp: 100, h: 6.70, hs: 19.04 },
      { rp: 200, h: 6.95, hs: 20.88 },
      { rp: 300, h: 7.07, hs: 21.90 },
      { rp: 400, h: 7.15, hs: 22.59 },
      { rp: 500, h: 7.20, hs: 23.12 },
    ],

    img1: 'assets/water_level/Old Lyme_wl.png',

    img2: 'assets/wave/Old Lyme_wave.png',
  },
  {
    name: 'East Lyme',
    lat: 41.277576,
    lon: -72.213326,
    depth: 47,

    table: [
      { rp: 2, h: 2.91, hs: 5.10 },
      { rp: 3, h: 3.63, hs: 7.38 },
      { rp: 4, h: 4.04, hs: 8.72 },
      { rp: 5, h: 4.31, hs: 9.65 },
      { rp: 6, h: 4.51, hs: 10.36 },
      { rp: 7, h: 4.67, hs: 10.92 },
      { rp: 8, h: 4.80, hs: 11.39 },
      { rp: 9, h: 4.91, hs: 11.79 },
      { rp: 10, h: 5.00, hs: 12.13 },
      { rp: 20, h: 5.53, hs: 14.19 },
      { rp: 30, h: 5.78, hs: 15.24 },
      { rp: 40, h: 5.94, hs: 15.93 },
      { rp: 50, h: 6.06, hs: 16.44 },
      { rp: 60, h: 6.14, hs: 16.83 },
      { rp: 70, h: 6.21, hs: 17.16 },
      { rp: 80, h: 6.27, hs: 17.43 },
      { rp: 90, h: 6.32, hs: 17.66 },
      { rp: 100, h: 6.36, hs: 17.87 },
      { rp: 200, h: 6.61, hs: 19.10 },
      { rp: 300, h: 6.73, hs: 19.75 },
      { rp: 400, h: 6.80, hs: 20.17 },
      { rp: 500, h: 6.86, hs: 20.49 },
    ],

    img1: 'assets/water_level/East Lyme_wl.png',

    img2: 'assets/wave/East Lyme_wave.png',
  },
  {
    name: 'Waterford',
    lat: 41.298508,
    lon: -72.17469,
    depth: 35,

    table: [
      { rp: 2, h: 3.01, hs: 4.70 },
      { rp: 3, h: 3.59, hs: 6.69 },
      { rp: 4, h: 3.94, hs: 7.90 },
      { rp: 5, h: 4.19, hs: 8.76 },
      { rp: 6, h: 4.39, hs: 9.42 },
      { rp: 7, h: 4.55, hs: 9.96 },
      { rp: 8, h: 4.69, hs: 10.41 },
      { rp: 9, h: 4.81, hs: 10.80 },
      { rp: 10, h: 4.91, hs: 11.14 },
      { rp: 20, h: 5.56, hs: 13.23 },
      { rp: 30, h: 5.91, hs: 14.35 },
      { rp: 40, h: 6.16, hs: 15.11 },
      { rp: 50, h: 6.34, hs: 15.67 },
      { rp: 60, h: 6.49, hs: 16.12 },
      { rp: 70, h: 6.61, hs: 16.49 },
      { rp: 80, h: 6.71, hs: 16.81 },
      { rp: 90, h: 6.80, hs: 17.08 },
      { rp: 100, h: 6.88, hs: 17.32 },
      { rp: 200, h: 7.39, hs: 18.83 },
      { rp: 300, h: 7.67, hs: 19.65 },
      { rp: 400, h: 7.87, hs: 20.21 },
      { rp: 500, h: 8.02, hs: 20.63 },
    ],

    img1: 'assets/water_level/Waterford_wl.png',

    img2: 'assets/wave/Waterford_wave.png',
  },
  {
    name: 'New London',
    lat: 41.29637,
    lon: -72.07844,
    depth: 41,

    table: [
      { rp: 2, h: 2.97, hs: 4.46 },
      { rp: 3, h: 3.48, hs: 6.75 },
      { rp: 4, h: 3.81, hs: 8.05 },
      { rp: 5, h: 4.04, hs: 8.94 },
      { rp: 6, h: 4.23, hs: 9.61 },
      { rp: 7, h: 4.38, hs: 10.14 },
      { rp: 8, h: 4.51, hs: 10.57 },
      { rp: 9, h: 4.62, hs: 10.94 },
      { rp: 10, h: 4.72, hs: 11.25 },
      { rp: 20, h: 5.34, hs: 13.08 },
      { rp: 30, h: 5.69, hs: 13.98 },
      { rp: 40, h: 5.93, hs: 14.56 },
      { rp: 50, h: 6.11, hs: 14.98 },
      { rp: 60, h: 6.26, hs: 15.30 },
      { rp: 70, h: 6.38, hs: 15.56 },
      { rp: 80, h: 6.49, hs: 15.78 },
      { rp: 90, h: 6.58, hs: 15.97 },
      { rp: 100, h: 6.66, hs: 16.13 },
      { rp: 200, h: 7.19, hs: 17.08 },
      { rp: 300, h: 7.49, hs: 17.56 },
      { rp: 400, h: 7.70, hs: 17.87 },
      { rp: 500, h: 7.86, hs: 18.10 },
    ],

    img1: 'assets/water_level/New London_wl.png',

    img2: 'assets/wave/New London_wave.png',
  },
  {
    name: 'Groton',
    lat: 41.300606,
    lon: -72.021935,
    depth: 33,

    table: [
      { rp: 2, h: 2.94, hs: 3.47 },
      { rp: 3, h: 3.44, hs: 6.08 },
      { rp: 4, h: 3.75, hs: 7.36 },
      { rp: 5, h: 3.98, hs: 8.15 },
      { rp: 6, h: 4.15, hs: 8.69 },
      { rp: 7, h: 4.30, hs: 9.09 },
      { rp: 8, h: 4.42, hs: 9.41 },
      { rp: 9, h: 4.53, hs: 9.66 },
      { rp: 10, h: 4.62, hs: 9.87 },
      { rp: 20, h: 5.21, hs: 10.92 },
      { rp: 30, h: 5.54, hs: 11.35 },
      { rp: 40, h: 5.76, hs: 11.59 },
      { rp: 50, h: 5.93, hs: 11.75 },
      { rp: 60, h: 6.07, hs: 11.87 },
      { rp: 70, h: 6.19, hs: 11.95 },
      { rp: 80, h: 6.29, hs: 12.02 },
      { rp: 90, h: 6.37, hs: 12.08 },
      { rp: 100, h: 6.45, hs: 12.13 },
      { rp: 200, h: 6.94, hs: 12.37 },
      { rp: 300, h: 7.22, hs: 12.47 },
      { rp: 400, h: 7.41, hs: 12.53 },
      { rp: 500, h: 7.56, hs: 12.57 },
    ],

    img1: 'assets/water_level/Groton_wl.png',

    img2: 'assets/wave/Groton_wave.png',
  },
  {
    name: 'Stonington',
    lat: 41.308628,
    lon: -71.94396,
    depth: 37,

    table: [
      { rp: 2, h: 3.05, hs: 4.57 },
      { rp: 3, h: 3.48, hs: 6.76 },
      { rp: 4, h: 3.75, hs: 8.13 },
      { rp: 5, h: 3.95, hs: 9.14 },
      { rp: 6, h: 4.11, hs: 9.93 },
      { rp: 7, h: 4.24, hs: 10.58 },
      { rp: 8, h: 4.35, hs: 11.13 },
      { rp: 9, h: 4.45, hs: 11.62 },
      { rp: 10, h: 4.53, hs: 12.04 },
      { rp: 20, h: 5.08, hs: 14.74 },
      { rp: 30, h: 5.39, hs: 16.25 },
      { rp: 40, h: 5.60, hs: 17.30 },
      { rp: 50, h: 5.76, hs: 18.10 },
      { rp: 60, h: 5.90, hs: 18.75 },
      { rp: 70, h: 6.01, hs: 19.29 },
      { rp: 80, h: 6.11, hs: 19.76 },
      { rp: 90, h: 6.19, hs: 20.17 },
      { rp: 100, h: 6.27, hs: 20.53 },
      { rp: 200, h: 6.76, hs: 22.88 },
      { rp: 300, h: 7.04, hs: 24.22 },
      { rp: 400, h: 7.23, hs: 25.16 },
      { rp: 500, h: 7.39, hs: 25.87 },
    ],

    img1: 'assets/water_level/Stonington_wl.png',

    img2: 'assets/wave/Stonington_wave.png',
  },
];

  selectedTown;

  constructor() { }

  ngOnInit() {
    this.data.sort((a, b) => {
      if( a.name > b.name )
        return 1;
      else if( b.name > a.name )
        return -1;
      else
        return 0;
    });
  }

  GetDataByName(name: string) {
    const dataIndex = this.data.map(d => d.name).indexOf(name);

    if( dataIndex === -1 )
      return null;
    else
      return this.data[dataIndex];
  }

  OnChange(event) {
    console.log(event);

    this.selectedTown = this.GetDataByName(event.target.value);
  }
}